import {SEAT_DETAILS, SELECTED_SSRS_SEAT_IDENTIFICATION} from './SeatType'


const initialState={
    SeatResponseData :'',
    SeatIdentification: []
}

const seatReducer=(state=initialState,action)=>
{   
     
    switch(action.type)
    {
        case SEAT_DETAILS: return{
            ...state,
            SeatResponseData:action.SeatResponseData
        }
        case SELECTED_SSRS_SEAT_IDENTIFICATION: return {
            SeatIdentification: action.SeatIdentification
        }
        default: return state
    }
}

export default seatReducer;